"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimTokenDialogForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const ClaimTokenDialogForm = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 1], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { slotProps: {
                    popper: {
                        sx: {
                            "& .MuiPickersTextField-root": {
                                margin: 0,
                            },
                        },
                    },
                }, size: "small", name: "endTimestamp", format: "dd/LL/yyyy hh:mm a" }), (0, jsx_runtime_1.jsx)(mui_inputs_asset_1.TokenAssetInput, { required: true, multiple: true, prefix: "item", contract: { data: { contractModule: [types_1.ModuleType.HIERARCHY, types_1.ModuleType.MYSTERY] } }, tokenType: { disabledOptions: [types_1.TokenType.NATIVE] } })] }));
};
exports.ClaimTokenDialogForm = ClaimTokenDialogForm;
//# sourceMappingURL=index.js.map